<p *ngIf="!messages.length && !isLoading">{{ "oms.no-messages" | translate }}</p>
<div class="oms-cards" *ngIf="messages.length">
	<obg-m-overlay-spinner *ngIf="!messages.length && isLoading"></obg-m-overlay-spinner>
	<mat-card *ngFor="let message of messages; let index = index; trackBy:trackMessage">
		<mat-card-header>
			<obg-lazy-image
				[src]="message.content?.image.url"
				[alt]="message.content?.image.altText"
				attr.test-id="oms-image-{{index}}"
			></obg-lazy-image>

			<mat-card-title attr.test-id="oms-title-{{index}}">
				{{ message.content.title | translate }}
			</mat-card-title>
		</mat-card-header>

		<mat-card-subtitle *ngIf="message.content?.subHeadline" attr.test-id="oms-sub-heading-{{index}}">
			{{ message.content.subHeadline | translate }}
		</mat-card-subtitle>

		<p class="received-date" *ngIf="status" attr.test-id="oms-received-date-{{ index }}">
			{{ "oms.received-on" | translate }} {{ message.sendDate | date: "longDate" }}
		</p>

		<mat-card-content>
			<obg-expandable-text
				*ngIf="message | obgOmsMessageContentProp: 'body' as body"
				obgOmsLocalizeTime
				[text]="body"
				[options]="expandableTextOptions"
				[readLess]="' ' + ('general.read-less' | translate)"
				[readMore]="' ' + ('general.read-more' | translate)"
				attr.test-id="oms-expandable-text-{{ index }}"
			/>
		</mat-card-content>

		<mat-card-actions>
			<button
				color="primary"
				class="obg-m-sm-oms-delete-button"
				mat-button
				(click)="onDeleteMessageClick(message.id)"
				attr.test-id="oms-delete-{{ index }}"
			>
				<span class="ico-trash"></span>
				<span>{{ "general.delete" | translate }}</span>
			</button>

			<button
				*ngIf="status === activeMessageStatus"
				color="accent"
				class="obg-m-sm-oms-cta-button"
				mat-flat-button
				(click)="onMessageCtaClick(message)"
				attr.test-id="oms-cta-{{index}}"
			>
				{{ message.content?.cta.text }}
			</button>
		</mat-card-actions>

		<div
			*ngIf="message | obgOmsMessageContentProp: 'significantTerms' as significantTerms"
			class="significant-terms"
			attr.test-id="oms-significant-terms-{{index}}"
		>
			<p obgOmsLocalizeTime [innerHtml]="significantTerms"></p>
		</div>

		<div
			*ngIf="message | obgOmsMessageContentProp: 'termsAndConditions' as termsAndConditions"
			class="terms-and-agreements"
		>
			<obg-m-sm-terms-and-conditions-accordion
				obgOmsLocalizeTime
				[content]="termsAndConditions"
				attr.test-id="oms-terms-and-conditions-{{index}}"
			/>
		</div>
	</mat-card>
</div>
